import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Thesis} from 'shared/classes/thesis';

@Injectable()
export class ThesisOverviewRepository {

  constructor(private http: Http) { }

  public getTheses(): Observable<Array<Thesis>> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(`${environment.theses}?withRating=true`, options)
      .map((theses: Response) => {
        return theses.json();
      });
  }

  public deleteThesis(id: string): Observable<Response> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.delete(`${environment.theses}/${id}`, options);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-overview/repositories/thesis-overview.repository.ts